"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./styles.scss");
var MobileButton = function (_a) {
    var localization = _a.localization, iconClassName = _a.iconClassName, onClick = _a.onClick;
    return (React.createElement("div", { className: "mobile-button-container", onClick: onClick },
        React.createElement(sok_ui_1.Button, { icon: React.createElement(sok_ui_1.Icon, { className: iconClassName }), size: "small", color: "white" }),
        React.createElement("div", null, (0, translation_1.getLocalization)("".concat(localization)))));
};
exports.default = MobileButton;
